<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-message-box`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 4a2 2 0 012 2v10a2 2 0 01-2 2h-2v24a2 2 0 01-2 2H8a2 2 0 01-2-2V18H4a2 2 0 01-2-2V6a2 2 0 012-2h40zm-6 14H10v22h28V18zm-7 4a1 1 0 011 1v2a1 1 0 01-1 1H17a1 1 0 01-1-1v-2a1 1 0 011-1h14zM42 8H6v6h36V8z"/></svg>
</template>
<script>

export default {
  name: 'IconMessageBox',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
